import api from '@/service/driver';
import createStore from '@/store/base/create-store';
const { state, actions, mutations } = createStore(api);

const tempState = {
    // 是否nioapp打开
    isNIOApp: false,
    showCustomHeader: false,
    // 登陆信息
    loginInfo: {},
    testDriveOrderList: [],
    testDriveOrderInfo: {},
    orderNo: '',
    ...state
};

const tempMutations = {
    ...mutations,
    setIsNIOApp(state, data) {
        state.isNIOApp = data;
    },
    setShowCustomHeader(state, data) {
        state.showCustomHeader = data;
    },
    setLoginInfo(state, data) {
        state.loginInfo = data || {};
    },
    setTestDriveOrderList(state, data) {
        state.testDriveOrderList = data || [];
    },
    setDriveOrderInfo(state, data) {
        state.testDriveOrderInfo = data || {};
    },
    setOrderNo(state, data) {
        state.orderNo = data || {};
    }
};

const tempActions = {
    ...actions,
    /**
     * 试驾单列表
     * @param {*} param0 
     * @param {*} param 
     */
    getTestDriveOrders({ dispatch, commit, state }, param) {
        return dispatch('testDriveOrderList', param).then(res => {
            const orders = (res.data.list || []).map(item => {
                let tags = [];
                if (item.car_types_name || item.car_type_name) {
                    tags = (item.car_types_name || item.car_type_name).split(
                        ','
                    );
                } else if (item.car_types || item.car_type) {
                    tags = (item.car_types || item.car_type)
                        .toUpperCase()
                        .split(',')
                        .map(t => (t === 'TT5' ? 'ET5 Touring' : t));
                }
                // 没有车型不显示tags
                return {
                    ...item,
                    title: '试驾行程单',
                    tags,
                    img: item.car_image || '../../asserts/img/order-empty.png'
                };
            });
            commit('setTestDriveOrderList', orders);
            return res;
        });
    },
    getTestDriveOrderInfo({ dispatch, commit }, param) {
        return dispatch('userIdentityTestDriveByOrderNoV2', param).then(res => {
            console.log('orderInfo', res.data);
            if (res.data) {
                res.data.order_no = param.order_no;
                commit('setDriveOrderInfo', res.data);
            }
            return res;
        });
  },
};
const tempGetters = {};

const store = {
    namespaced: true,
    strict: true,
    state: tempState,
    actions: tempActions,
    mutations: tempMutations,
    getters: tempGetters
};
export default store;



// WEBPACK FOOTER //
// ./src/store/orders.js